function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: block;\n  margin-top: 0.75rem; /* mt-3 */\n  border: 1px solid;\n  border-color: #e5e7eb; /* border-gray-200 */\n  border-radius: 0.75rem; /* rounded-xl */\n  overflow: hidden;\n  transition: background-color 0.2s;\n  \n  &:hover {\n    background-color: #f9fafb; /* hover:bg-gray-50 */\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  width: 100%;\n  height: 10rem; /* h-40 */\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  padding: 0.75rem; /* p-3 */\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.875rem; /* text-sm */\n  color: #6b7280; /* text-gray-500 */\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  font-weight: 700; /* font-bold */\n  font-size: 1rem; /* text-base */\n  margin-top: 0.25rem; /* mt-1 */\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.875rem; /* text-sm */\n  color: #374151; /* text-gray-700 */\n  margin-top: 0.25rem; /* mt-1 */\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.875rem; /* text-sm */\n  color: #6b7280; /* text-gray-500 */\n  margin-top: 0.25rem; /* mt-1 */\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from '@emotion/styled';
// 링크 미리보기 스타일
export var LinkPreviewCard = styled.a(_templateObject());
export var LinkPreviewImage = styled.div(_templateObject1());
export var LinkPreviewContent = styled.div(_templateObject2());
export var LinkPreviewSite = styled.div(_templateObject3());
export var LinkPreviewTitle = styled.div(_templateObject4());
export var LinkPreviewDescription = styled.div(_templateObject5());
export var LinkPreviewUrl = styled.div(_templateObject6());
